import React, { Component } from 'react';
import {
  CONSENT_CATEGORIES,
  getDefaultConsent,
  loadConsent,
  saveConsent,
  hasValidConsent,
} from '../utils/cookieConsent';
import './CookieConsent.css';

/**
 * GDPR-compliant cookie consent banner.
 *
 * Shows a bottom banner with:
 *  - "Alle akzeptieren" (accept all)
 *  - "Nur Notwendige" (accept necessary only)
 *  - "Anpassen" (open detail view with sliders)
 *
 * In the detail view each optional category has a toggle slider.
 * Necessary cookies are always enabled and the toggle is locked.
 */
class CookieConsent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      showDetails: false,
      preferences: getDefaultConsent(),
    };
  }

  componentDidMount() {
    if (!hasValidConsent()) {
      this.setState({ visible: true });
    }
  }

  handleAcceptAll = () => {
    const prefs = { necessary: true, analytics: true, marketing: true };
    saveConsent(prefs);
    this.setState({ visible: false, preferences: prefs });
    if (this.props.onConsentChanged) this.props.onConsentChanged(prefs);
  };

  handleAcceptNecessary = () => {
    const prefs = getDefaultConsent();
    saveConsent(prefs);
    this.setState({ visible: false, preferences: prefs });
    if (this.props.onConsentChanged) this.props.onConsentChanged(prefs);
  };

  handleSaveCustom = () => {
    const prefs = { ...this.state.preferences, necessary: true };
    saveConsent(prefs);
    this.setState({ visible: false });
    if (this.props.onConsentChanged) this.props.onConsentChanged(prefs);
  };

  handleToggle = (key) => {
    if (CONSENT_CATEGORIES[key].required) return; // necessary cannot be toggled
    this.setState((prev) => ({
      preferences: {
        ...prev.preferences,
        [key]: !prev.preferences[key],
      },
    }));
  };

  openDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  render() {
    if (!this.state.visible) return null;

    const { showDetails, preferences } = this.state;
    const categories = Object.values(CONSENT_CATEGORIES);

    return (
      <div className="cc-overlay">
        <div className="cc-banner">
          {/* ─── Main Banner ─── */}
          {!showDetails && (
            <>
              <div className="cc-header">
                <h2 className="cc-title">Cookie-Einstellungen</h2>
              </div>

              <div className="cc-body">
                <p className="cc-text">
                  Wir verwenden Cookies und ähnliche Technologien, um Ihnen die
                  bestmögliche Nutzung unserer Website zu ermöglichen. Einige
                  davon sind notwendig, während andere uns helfen, die Website
                  und Ihr Erlebnis zu verbessern. Weitere Informationen finden
                  Sie in unserer{' '}
                  <a href="/privacy" className="cc-link">
                    Datenschutzerklärung
                  </a>
                  .
                </p>
              </div>

              <div className="cc-actions">
                <button
                  className="cc-btn cc-btn-primary"
                  onClick={this.handleAcceptAll}
                >
                  Alle akzeptieren
                </button>
                <button
                  className="cc-btn cc-btn-secondary"
                  onClick={this.handleAcceptNecessary}
                >
                  Nur Notwendige
                </button>
                <button
                  className="cc-btn cc-btn-outline"
                  onClick={this.openDetails}
                >
                  Anpassen
                </button>
              </div>
            </>
          )}

          {/* ─── Detail / Customise View ─── */}
          {showDetails && (
            <>
              <div className="cc-header">
                <h2 className="cc-title">Cookie-Einstellungen anpassen</h2>
              </div>

              <div className="cc-body cc-details-body">
                {categories.map((cat) => (
                  <div className="cc-category" key={cat.key}>
                    <div className="cc-category-header">
                      <div className="cc-category-info">
                        <span className="cc-category-label">{cat.label}</span>
                        {cat.required && (
                          <span className="cc-badge">Immer aktiv</span>
                        )}
                      </div>
                      <label className="cc-switch">
                        <input
                          type="checkbox"
                          checked={
                            cat.required ? true : preferences[cat.key]
                          }
                          disabled={cat.required}
                          onChange={() => this.handleToggle(cat.key)}
                        />
                        <span
                          className={`cc-slider ${
                            cat.required ? 'cc-slider-locked' : ''
                          }`}
                        />
                      </label>
                    </div>
                    <p className="cc-category-desc">{cat.description}</p>
                  </div>
                ))}
              </div>

              <div className="cc-actions">
                <button
                  className="cc-btn cc-btn-primary"
                  onClick={this.handleSaveCustom}
                >
                  Auswahl speichern
                </button>
                <button
                  className="cc-btn cc-btn-primary"
                  onClick={this.handleAcceptAll}
                >
                  Alle akzeptieren
                </button>
                <button
                  className="cc-btn cc-btn-outline"
                  onClick={this.closeDetails}
                >
                  Zurück
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default CookieConsent;
